import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const CartBillingIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.47241 4.50001C3.86373 4.50001 4.07012 4.50163 4.21522 4.51877L4.22131 4.51951L4.22363 4.5252C4.27834 4.66068 4.33421 4.85936 4.43717 5.23689L4.8477 6.74217C4.8513 6.75665 4.85522 6.77101 4.85945 6.78523L5.84497 10.3988C6.12166 11.4135 6.35217 12.2587 6.62015 12.9223C6.77108 13.296 6.94457 13.6409 7.16438 13.9506C7.15466 13.9655 7.14527 13.9806 7.13623 13.9961L6.26349 15.4922C5.48573 16.8256 6.44747 18.5 7.99105 18.5H19C19.5523 18.5 20 18.0523 20 17.5C20 16.9477 19.5523 16.5 19 16.5L7.99105 16.5L8.76793 15.1682C9.11932 15.2948 9.49164 15.3696 9.88517 15.4161C10.5959 15.5001 11.472 15.5 12.5237 15.5L14.1681 15.5C15.0665 15.5 15.8186 15.5001 16.4363 15.4342C17.0897 15.3645 17.6813 15.2142 18.2317 14.8579C18.782 14.5016 19.1614 14.0234 19.4925 13.4558C19.8055 12.9193 20.1134 12.2331 20.4812 11.4134L21.2658 9.665C21.5264 9.08452 21.7661 8.55054 21.892 8.10376C22.0273 7.62353 22.1039 6.9999 21.7241 6.4132C21.3443 5.82649 20.744 5.64105 20.2505 5.56789C19.7913 5.49984 19.206 5.49992 18.5697 5.50001L6.58198 5.50001L6.35497 4.66762C6.26861 4.3507 6.18252 4.0348 6.07811 3.77627C5.95902 3.48138 5.7795 3.16212 5.45019 2.9106C5.12088 2.65908 4.76564 2.56988 4.44981 2.53258C4.17291 2.49987 3.8455 2.49994 3.51701 2.50001L3 2.50001C2.44772 2.50001 2 2.94773 2 3.50001C2 4.0523 2.44772 4.50001 3 4.50001H3.47241ZM7.75896 9.8156L7.12743 7.50001H18.5004C19.2298 7.50001 19.6629 7.50265 19.9572 7.54628L19.9706 7.5483L19.967 7.56131C19.8863 7.8477 19.7113 8.24394 19.4127 8.90943L18.6778 10.5471C18.2831 11.4266 18.0179 12.0145 17.7649 12.4481C17.5241 12.861 17.3385 13.0536 17.1448 13.179C16.9512 13.3043 16.6995 13.3948 16.2242 13.4455C15.725 13.4987 15.0801 13.5 14.1161 13.5H12.5828C11.4568 13.5 10.6994 13.4984 10.1198 13.4299C9.56653 13.3646 9.28565 13.2485 9.0774 13.0894C8.86915 12.9304 8.68324 12.6899 8.47463 12.1734C8.25607 11.6322 8.05523 10.9019 7.75896 9.8156Z"
          fill="#0B0B0B"
        />
        <path
          d="M8.5 22.5C9.32843 22.5 10 21.8284 10 21C10 20.1716 9.32843 19.5 8.5 19.5C7.67157 19.5 7 20.1716 7 21C7 21.8284 7.67157 22.5 8.5 22.5Z"
          fill="#0B0B0B"
        />
        <path
          d="M17.5 22.5C18.3284 22.5 19 21.8284 19 21C19 20.1716 18.3284 19.5 17.5 19.5C16.6716 19.5 16 20.1716 16 21C16 21.8284 16.6716 22.5 17.5 22.5Z"
          fill="#0B0B0B"
        />
      </svg>
    );
  }
);
export default CartBillingIcon;
